<template>
  <div
    id="ranges"
    class="row"
  >
    <div class="col-12">
      <vuetify-table
          :type="type"
          :headers="headers"
          :api-u-r-l="apiURL"
          :title="title"
          :query-params="queryParams"
          :is-numeration="isNumeration"
          permisosNuevoRegistro="crear_numeracion_empresa"
          permisosEditar="editar_numeracion_empresa"
          permisosEliminar="eliminar_numeracion_empresa"
          :readonly="!!dealerId"
        >
          <template v-slot:actions-filters>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="can('autoregistro_numeracion_empresa') && !dealerId"
                  style="margin-right: 5px;"
                  :color="themeColor"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="automatic"
                >
                  Autoregistro
                </v-btn>
              </template>
              <span>Realizar busqueda</span>
            </v-tooltip>
        </template>
      </vuetify-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VuetifyTable from '~/components/VuetifyTable';

export default {
  middleware: 'auth',
  components: {
    VuetifyTable,
  },
  props: {
    enterpriseId: { default: '' },
    dealerId: { default: '' },
  },
  data: () => ({
    currentTitle: '',
    queryParams: '',
    type: '',
    dialog: false,
    toggleStatus: false,
    headers: [
      {
        text: 'Titulo',
        value: 'title',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Tipo Documento',
        value: 'type_document',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Serie',
        value: 'serie',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Prefijo',
        value: 'prefix',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Desde',
        value: 'min_value',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Hasta',
        value: 'max_value',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Correlativo',
        value: 'correlative',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Estado',
        value: 'active',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Acciones',
        value: 'action',
        sortable: false,
      },
    ],
    name: '',
    isNumeration: true,
  }),
  computed: {
    apiURL() {
      return this.dealerId
      ? `/api/enterprises/${this.enterpriseId}/${this.dealerId}/series_dealer`
      : `/api/enterprises/${this.enterpriseId}/series`;
    },
    title() {
      return 'Numeraciones';
    },
    ...mapGetters({
      themeColor: 'theme/themeColor',
    }),
  },
  mounted() {
    if (!this.can('cambiar_estado_numeracion_empresa')) {
      this.headers.splice(this.headers.findIndex(({ text }) => text === 'Estado'), 1);
    }
    if (!this.can('editar_numeracion_empresa') && !this.can('eliminar_numeracion_empresa')) {
      this.headers.splice(this.headers.findIndex(({ text }) => text === 'Acciones'), 1);
    }
  },
  methods: {
    automatic() {
        this.$router.push({ path: `${this.$router.currentRoute.path}/autoregistro` });
    },
    openModalPass(item) {
      const editedItem = item.id;
      this.$router.push({ path: `${this.$router.currentRoute.path}/${editedItem}/invoice`, params: { counterId: editedItem } });
    },

  },
};
</script>
